import { render, staticRenderFns } from "./SecurityOTPToggleSetting.vue?vue&type=template&id=1f1db910&scoped=true"
import script from "./SecurityOTPToggleSetting.vue?vue&type=script&lang=js"
export * from "./SecurityOTPToggleSetting.vue?vue&type=script&lang=js"
import style0 from "./SecurityOTPToggleSetting.vue?vue&type=style&index=0&id=1f1db910&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1db910",
  null
  
)

export default component.exports